import React from "react";
import Badge, { BadgeProps } from "@mui/material/Badge";

export const WcBadge = ({ badgeContent, color = "default", ...rest }: BadgeProps) => (
  <Badge color={color} badgeContent={badgeContent} {...rest} />
);

export default WcBadge;
